import request from "@/common/request"
import { ValePresente } from "@/models/views/ValePresente"

const basePath = '/vale-presente'

export const findValeValido = (identificador: string, grupoEconomicoId: string): Promise<ValePresente> =>
	request.get(`${basePath}/${identificador}?grupoEconomicoId=${grupoEconomicoId}`)

export const findValesPresentesByVendaId = (vendaId: string): Promise<ValePresente[]> =>
	request.get(`${basePath}/venda/${vendaId}`)

export const enviarValePresentePorWhatsapp = (vendaId: string): Promise<void> =>
	request.post(`${basePath}/enviar-whatsapp/${vendaId}`)

export const findValesPresentesByVendaIdPublico = (vendaId: string): Promise<ValePresente[]> =>
	request.get(`/public${basePath}/venda/${vendaId}`)